import gql from 'graphql-tag';

import { clientVoucher, orderOutput, organisationUser, user, userConfig } from '../fragments';

export const createUser = gql`
    mutation CreateUser($input: CreateUserInput!) {
        createUser(input: $input) {
            user {
                success
            }
            confirmationToken
        }
    }
`;

export const resetPassword = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
            success
        }
    }
`;

export const createUserPassword = gql`
    mutation CreateUserPassword($input: UserPasswordInput!) {
        createUserPassword(input: $input) {
            ...UserFragment
            userConfig {
                ...ConfigFragment
            }
        }
    }
    ${user}
    ${userConfig}
`;

export const changeUserPassword = gql`
    mutation ChangeUserPassword($userId: Int!, $input: ChangeUserPasswordInput!) {
        changeUserPassword(userId: $userId, input: $input) {
            ...UserFragment
        }
    }
    ${user}
`;

export const createOrganisationUser = gql`
    mutation CreateOrganisationUser($input: OrganisationUserInput!) {
        createOrganisationUser(input: $input) {
            ...OrganisationUserFragment
        }
    }
    ${organisationUser}
`;

export const updateOrganisationUser = gql`
    mutation UpdateOrganisationUser($input: OrganisationUserInput!) {
        updateOrganisationUser(input: $input) {
            ...OrganisationUserFragment
        }
    }
    ${organisationUser}
`;

export const updateUserById = gql`
    mutation UpdateUserById($userId: Int!, $input: UpdateUserByIdInput!) {
        updateUserById(userId: $userId, input: $input) {
            ...UserFragment
        }
    }
    ${user}
`;

export const buyEntryPass = gql`
    mutation BuyEntryPass($userId: Int!, $officeId: Int!, $input: BuyCreditPassInput!) {
        buyEntryPass(userId: $userId, officeId: $officeId, input: $input) {
            ...OrderOutputFragment
        }
    }
    ${orderOutput}
`;

export const buyCredit = gql`
    mutation BuyCredit($userId: Int!, $officeId: Int!, $input: BuyCreditPassInput!) {
        buyCredit(userId: $userId, officeId: $officeId, input: $input) {
            ...OrderOutputFragment
        }
    }
    ${orderOutput}
`;

export const buyVoucher = gql`
    mutation BuyVoucher($officeId: Int!, $input: BuyVoucherInput!) {
        buyVoucher(officeId: $officeId, input: $input) {
            ...OrderOutputFragment
        }
    }
    ${orderOutput}
`;

export const claimVoucher = gql`
    mutation ClaimVoucher($officeId: Int!, $input: ClaimVoucherInput!) {
        claimVoucher(officeId: $officeId, input: $input) {
            ...ClientVoucherFragment
        }
    }
    ${clientVoucher}
`;
